import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  listScriptsApi,
  getScriptApi,
  activateScriptApi,
  archiveScriptApi,
  listScriptDeploymentsApi,
} from "@/lib/api";

export function useConversationScripts(filters?: { agentType?: string; status?: string }) {
  return useQuery({
    queryKey: ["super-admin", "scripts", filters],
    queryFn: () => listScriptsApi(filters),
  });
}

export function useConversationScript(id: string | undefined) {
  return useQuery({
    queryKey: ["super-admin", "scripts", id],
    queryFn: () => getScriptApi(id!),
    enabled: !!id,
  });
}

export function useScriptDeployments(id: string | undefined) {
  return useQuery({
    queryKey: ["super-admin", "scripts", id, "deployments"],
    queryFn: () => listScriptDeploymentsApi(id!),
    enabled: !!id,
  });
}

export function useActivateScript(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => activateScriptApi(id),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["super-admin", "scripts"] }),
  });
}

export function useArchiveScript(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => archiveScriptApi(id),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["super-admin", "scripts"] }),
  });
}
